import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Menu from '../components/Menu';
import { FaRegCalendarAlt, FaRegClock } from 'react-icons/fa';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

const Terms = () => {
    const { t, i18n } = useTranslation()

    return (
        <>
            <div className='main-content'>
                <Header page={""} title={t("Terms of Service")} backpage={'/'} />
                <div className='padding2'>
                    <div className='container'>
                        <h4 className='fw-bold mb-3'>{t("Terms of Service")}</h4>
                        <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sed mollitia esse laboriosam animi molestias eaque nihil qui recusandae voluptas asperiores numquam velit ipsa, quaerat deserunt necessitatibus exercitationem fugiat, nisi aliquam?</p>
                        <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Voluptatibus voluptates dolorum, ratione doloremque quae quibusdam veritatis eaque ducimus sapiente temporibus atque voluptatum eveniet ex unde commodi aut? Dolorem, in delectus!</p>
                        <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Officia tempore est ipsa ad ullam porro, sunt iusto. Suscipit, repellat nihil obcaecati, sint excepturi dicta, neque et eos qui quaerat quasi!</p>
                    </div>
                </div>
                <Menu />
            </div>
        </>
    );
};

export default Terms;
